import React from 'react';

export const MicroscopeSvg = (props) => {
  const { color = '#4A4A4A' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.0604 13.4808L14.8155 13.8253L15.1143 14.1241L20.8913 19.901C21.0171 20.0328 21.0867 20.2084 21.0851 20.3907C21.0835 20.5742 21.0099 20.7498 20.8801 20.8796C20.7503 21.0094 20.5748 21.083 20.3912 21.0846C20.209 21.0862 20.0333 21.0166 19.9016 20.8907L14.1259 15.115L13.827 14.8161L13.4826 15.0611C12.4802 15.7738 11.301 16.1969 10.0741 16.284C8.84727 16.371 7.62013 16.1187 6.52717 15.5546C5.43421 14.9905 4.5176 14.1365 3.87779 13.0861C3.23798 12.0357 2.89966 10.8294 2.8999 9.59945L2.8999 9.59929C2.89977 8.54483 3.14852 7.50522 3.62593 6.56502C4.10333 5.62482 4.79592 4.81058 5.64734 4.18851C6.49877 3.56645 7.48501 3.15413 8.52583 2.98509C9.56666 2.81605 10.6327 2.89506 11.6372 3.2157C12.6418 3.53634 13.5564 4.08955 14.3068 4.83034C15.0573 5.57113 15.6222 6.47858 15.9558 7.47889C16.2894 8.4792 16.3822 9.54412 16.2266 10.587C16.071 11.63 15.6714 12.6214 15.0604 13.4808ZM9.5999 4.29936C8.19425 4.29936 6.84618 4.85775 5.85224 5.85169C4.85829 6.84563 4.2999 8.19371 4.2999 9.59936C4.2999 11.005 4.85829 12.3531 5.85224 13.347C6.84618 14.341 8.19425 14.8994 9.5999 14.8994C11.0055 14.8994 12.3536 14.341 13.3476 13.347C14.3415 12.3531 14.8999 11.005 14.8999 9.59936C14.8999 8.19371 14.3415 6.84563 13.3476 5.85169C12.3536 4.85775 11.0055 4.29936 9.5999 4.29936Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export const RankingSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99984 1.04102C9.60067 1.04102 9.24673 1.29904 9.12256 1.67904L8.71077 2.94368H7.38102C6.98102 2.94368 6.62708 3.20171 6.50374 3.58171C6.38041 3.96171 6.51407 4.37698 6.8374 4.61198L7.91488 5.39486L7.50472 6.66113C7.38139 7.04113 7.51505 7.45641 7.83838 7.69141C8.16171 7.92641 8.59903 7.92641 8.92236 7.69141L9.99984 6.91016L11.0773 7.69141C11.4006 7.92641 11.838 7.92641 12.1613 7.69141C12.4846 7.45641 12.6183 7.04113 12.495 6.66113L12.0848 5.39486L13.1623 4.61198C13.4856 4.37698 13.6193 3.96171 13.4959 3.58171C13.3726 3.20171 13.0187 2.94368 12.6187 2.94368H11.2889L10.8771 1.67904C10.7529 1.29904 10.399 1.04102 9.99984 1.04102ZM9.99984 3.02344L10.2391 3.76237C10.3224 4.01987 10.564 4.19368 10.8348 4.19368H11.6112L10.9829 4.64941C10.7637 4.80858 10.6709 5.09178 10.755 5.34928L10.9959 6.08822L10.3677 5.63086C10.1485 5.47169 9.85116 5.47169 9.632 5.63086L9.00374 6.08822L9.24463 5.34928C9.3288 5.09178 9.23593 4.80858 9.01676 4.64941L8.38851 4.19368H9.16488C9.43571 4.19368 9.67725 4.01987 9.76058 3.76237L9.99984 3.02344ZM8.74984 8.95768C7.944 8.95768 7.2915 9.61102 7.2915 10.416V11.0622C7.223 11.0523 7.15442 11.041 7.08317 11.041H4.1665C3.36067 11.041 2.70817 11.6943 2.70817 12.4993V17.7077H1.6665C1.3215 17.7077 1.0415 17.9877 1.0415 18.3327C1.0415 18.6777 1.3215 18.9577 1.6665 18.9577H3.33317H7.9165H18.3332C18.6782 18.9577 18.9582 18.6777 18.9582 18.3327C18.9582 17.9877 18.6782 17.7077 18.3332 17.7077H17.7082V14.166C17.7082 13.361 17.0557 12.7077 16.2498 12.7077H13.3332C13.2619 12.7077 13.1933 12.719 13.1248 12.7288V10.416C13.1248 9.61102 12.4723 8.95768 11.6665 8.95768H8.74984ZM8.74984 10.2077H11.6665C11.7815 10.2077 11.8748 10.301 11.8748 10.416V17.7077H8.5415V12.4993V10.416C8.5415 10.301 8.63484 10.2077 8.74984 10.2077ZM4.1665 12.291H7.08317C7.19817 12.291 7.2915 12.3843 7.2915 12.4993V17.7077H3.95817V12.4993C3.95817 12.3843 4.0515 12.291 4.1665 12.291ZM13.3332 13.9577H16.2498C16.3648 13.9577 16.4582 14.051 16.4582 14.166V17.7077H13.1248V14.166C13.1248 14.051 13.2182 13.9577 13.3332 13.9577Z"
        fill="#F16B7C"
      />
    </svg>
  );
};

export const CircleArrowSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0001 12.8996C8.69748 12.8996 10.3253 12.2253 11.5256 11.0251C12.7258 9.82486 13.4001 8.19699 13.4001 6.49961C13.4001 4.80222 12.7258 3.17436 11.5256 1.97413C10.3253 0.773893 8.69748 0.0996094 7.0001 0.0996094C5.30271 0.0996094 3.67485 0.773893 2.47461 1.97413C1.27438 3.17436 0.600098 4.80222 0.600098 6.49961C0.600098 8.19699 1.27438 9.82486 2.47461 11.0251C3.67485 12.2253 5.30271 12.8996 7.0001 12.8996ZM5.5602 8.41961C5.5602 8.54689 5.61075 8.66896 5.70074 8.75897C5.79075 8.84896 5.91282 8.89951 6.0401 8.89951C6.16738 8.89951 6.28944 8.84896 6.37946 8.75897L8.29946 6.83897C8.38944 6.74896 8.44 6.62689 8.44 6.49961C8.44 6.37233 8.38944 6.25026 8.29946 6.16025L6.37946 4.24025C6.28893 4.15281 6.16768 4.10443 6.04183 4.10553C5.91597 4.10662 5.79558 4.1571 5.70658 4.2461C5.61759 4.33509 5.56711 4.45548 5.56601 4.58134C5.56492 4.70719 5.6133 4.82844 5.70074 4.91897L7.28138 6.49961L5.70074 8.08025C5.61075 8.17026 5.5602 8.29233 5.5602 8.41961Z"
        fill="#F16B7C"
      />
    </svg>
  );
};

export const TrashSvg = (props) => {
  const { color = '#9B9B9B' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.33325 9.16667V14.1667M11.6666 9.16667V14.1667M3.33325 5.83333H16.6666M15.8333 5.83333L15.1108 15.9517C15.0808 16.3722 14.8927 16.7657 14.5842 17.053C14.2757 17.3403 13.8698 17.5 13.4483 17.5H6.55158C6.13003 17.5 5.72414 17.3403 5.41566 17.053C5.10717 16.7657 4.91902 16.3722 4.88909 15.9517L4.16659 5.83333H15.8333ZM12.4999 5.83333V3.33333C12.4999 3.11232 12.4121 2.90036 12.2558 2.74408C12.0996 2.5878 11.8876 2.5 11.6666 2.5H8.33325C8.11224 2.5 7.90028 2.5878 7.744 2.74408C7.58772 2.90036 7.49992 3.11232 7.49992 3.33333V5.83333H12.4999Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronLeftSvg = (props) => {
  const { color = '#4A4A4A' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 19L8 12L15 5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CrossSvg = (props) => {
  const { color = '#4A4A4A' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="-2 -2 28 28"
      strokeWidth="2"
      stroke={color}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  );
};

export const SmallCrownSvg = (props) => {
  const { color = '#E4A108' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M5.36567 2.76294C5.69184 2.56177 5.7934 2.13404 5.59223 1.80786C5.39106 1.48169 4.96137 1.37818 4.6352 1.57935C4.30903 1.78052 4.20746 2.20826 4.40864 2.53443C4.46528 2.62622 4.5434 2.70435 4.6352 2.76099L3.64106 4.75122C3.50434 5.02661 3.17035 5.13794 2.89496 4.99927C2.85981 4.98169 2.82856 4.96021 2.79731 4.93677L1.25043 3.70044C1.4809 3.3938 1.4184 2.95826 1.11176 2.72779C0.80512 2.49732 0.369573 2.55982 0.139104 2.86646C-0.0913644 3.1731 -0.0288644 3.60865 0.277776 3.83911C0.39887 3.92896 0.543401 3.97779 0.693792 3.97779H0.705511L1.49848 8.61646C1.59418 9.14576 2.05512 9.53052 2.59223 9.53052H7.40473C7.94184 9.53052 8.40278 9.14576 8.49848 8.61646L9.29145 3.97779H9.30317C9.68598 3.97779 9.99653 3.66724 9.99653 3.28247C9.99653 2.89771 9.68598 2.58911 9.30317 2.58911C8.92035 2.58911 8.60981 2.89966 8.60981 3.28247C8.60981 3.43286 8.65864 3.57935 8.74848 3.69849L7.20161 4.93677C6.96137 5.12818 6.61176 5.08911 6.42036 4.84888C6.39692 4.81958 6.37543 4.78638 6.35786 4.75122L5.36567 2.76294Z"
        fill={color}
      />
    </svg>
  );
};

export const CrownSvg = (props) => {
  const { color = '#E4A108' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M23.0682 9.98937L19.725 14.4968L18.2519 7.55498L15.2263 13.2946L12.7079 5.02734L10.1895 13.2946L7.16391 7.55498L5.69081 14.4968L2.34766 9.98937L4.23094 18.7578C7.0169 18.0002 9.86166 17.6222 12.7079 17.6222C15.5541 17.6222 18.3989 18.0002 21.1849 18.7578L23.0682 9.98937Z"
        fill={color}
      />
      <path
        d="M12.7058 19.3494C15.4624 19.3494 18.219 19.709 20.9211 20.4234C20.9976 20.0654 21.0725 19.709 21.149 19.351C18.3748 18.5967 15.5403 18.2188 12.7073 18.2188C9.8743 18.2188 7.03983 18.5967 4.26562 19.351C4.34207 19.709 4.41705 20.0654 4.4935 20.4234C7.19566 19.709 9.95222 19.3494 12.7088 19.3494H12.7058Z"
        fill={color}
      />
      <path
        d="M12.7046 4.51561C13.0075 4.51561 13.253 4.23754 13.253 3.89452C13.253 3.55151 13.0075 3.27344 12.7046 3.27344C12.4018 3.27344 12.1562 3.55151 12.1562 3.89452C12.1562 4.23754 12.4018 4.51561 12.7046 4.51561Z"
        fill={color}
      />
      <path
        d="M18.4077 7.05858C18.7106 7.05858 18.9561 6.78051 18.9561 6.43749C18.9561 6.09448 18.7106 5.81641 18.4077 5.81641C18.1049 5.81641 17.8594 6.09448 17.8594 6.43749C17.8594 6.78051 18.1049 7.05858 18.4077 7.05858Z"
        fill={color}
      />
      <path
        d="M23.3062 9.78123C23.609 9.78123 23.8546 9.50316 23.8546 9.16015C23.8546 8.81713 23.609 8.53906 23.3062 8.53906C23.0033 8.53906 22.7578 8.81713 22.7578 9.16015C22.7578 9.50316 23.0033 9.78123 23.3062 9.78123Z"
        fill={color}
      />
      <path
        d="M7.0015 7.05858C7.30435 7.05858 7.54987 6.78051 7.54987 6.43749C7.54987 6.09448 7.30435 5.81641 7.0015 5.81641C6.69864 5.81641 6.45312 6.09448 6.45312 6.43749C6.45312 6.78051 6.69864 7.05858 7.0015 7.05858Z"
        fill={color}
      />
      <path
        d="M2.10306 9.78123C2.40592 9.78123 2.65143 9.50316 2.65143 9.16015C2.65143 8.81713 2.40592 8.53906 2.10306 8.53906C1.8002 8.53906 1.55469 8.81713 1.55469 9.16015C1.55469 9.50316 1.8002 9.78123 2.10306 9.78123Z"
        fill={color}
      />
    </svg>
  );
};

export const CopySvg = (props) => {
  const { color = '#111928' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M6.79766 6.49687V12.8969C6.79766 13.3212 6.96623 13.7282 7.26629 14.0282C7.56634 14.3283 7.97331 14.4969 8.39766 14.4969H13.1977M6.79766 6.49687V4.89687C6.79766 4.47253 6.96623 4.06556 7.26629 3.7655C7.56634 3.46545 7.97331 3.29688 8.39766 3.29688H12.0665C12.2786 3.29692 12.4821 3.38124 12.6321 3.53127L16.1633 7.06247C16.3133 7.21247 16.3976 7.41592 16.3977 7.62807V12.8969C16.3977 13.3212 16.2291 13.7282 15.929 14.0282C15.629 14.3283 15.222 14.4969 14.7977 14.4969H13.1977M6.79766 6.49687H5.19766C4.77331 6.49687 4.36634 6.66545 4.06629 6.9655C3.76623 7.26556 3.59766 7.67253 3.59766 8.09687V16.0969C3.59766 16.5212 3.76623 16.9282 4.06629 17.2282C4.36634 17.5283 4.77331 17.6969 5.19766 17.6969H11.5977C12.022 17.6969 12.429 17.5283 12.729 17.2282C13.0291 16.9282 13.1977 16.5212 13.1977 16.0969V14.4969"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MetricStarSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6699 7.5798L10.7849 7.12087C9.8434 6.89163 9.10835 6.15658 8.87911 5.21512L8.42015 3.33012C8.31296 2.88996 7.68701 2.88996 7.57983 3.33012L7.12086 5.21512C6.89162 6.15658 6.15657 6.89163 5.21512 7.12087L3.33012 7.57984C2.88996 7.68702 2.88996 8.31298 3.33012 8.42016L5.21512 8.87913C6.15657 9.10837 6.89162 9.84342 7.12086 10.7849L7.57983 12.6699C7.68701 13.11 8.31296 13.11 8.42015 12.6699L8.87911 10.7849C9.10835 9.84342 9.8434 9.10837 10.7849 8.87913L12.6699 8.42016C13.11 8.31294 13.11 7.68699 12.6699 7.5798Z"
        fill="#5882FF"
      />
    </svg>
  );
};

export const MetricFlowerSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.2949 7.99164C11.635 7.86377 11.9113 7.69327 12.1026 7.48015C12.6128 6.96866 12.9317 6.28667 12.9529 5.58336C12.9954 4.85875 12.7403 4.19807 12.2514 3.70789C11.7625 3.21771 11.0823 2.96197 10.3808 3.00459C9.67931 3.0259 8.99908 3.34559 8.48891 3.85708C8.2976 4.04889 8.12754 4.32595 7.97874 4.66694C7.8512 4.32595 7.68114 4.04889 7.46857 3.85708C6.9584 3.34559 6.27817 3.0259 5.57669 3.00459C4.85395 2.98328 4.19498 3.21771 3.70606 3.70789C3.21715 4.19807 2.96206 4.85875 3.00458 5.58336C3.02584 6.28667 3.34469 6.96866 3.85486 7.48015C4.04618 7.67196 4.32252 7.84245 4.66263 7.99164C4.32252 8.11951 4.04618 8.29001 3.85486 8.50313C3.34469 9.01462 3.02584 9.69661 3.00458 10.3999C2.96206 11.1245 3.21715 11.7852 3.70606 12.2754C4.17372 12.7443 4.79018 13 5.4704 13H5.59795C6.29943 12.9787 6.97966 12.659 7.48983 12.1475C7.68114 11.9557 7.8512 11.6786 8 11.3377C8.12754 11.6786 8.2976 11.9557 8.51017 12.1475C9.02034 12.659 9.70057 12.9787 10.4021 13H10.5296C11.2098 13 11.8263 12.7443 12.2939 12.2754C12.7829 11.7852 13.0379 11.1245 12.9954 10.3999C12.9742 9.69661 12.6553 9.01462 12.1451 8.50313C11.8901 8.29001 11.635 8.11951 11.2949 7.99164ZM7.95749 9.41956C7.17097 9.41956 6.53326 8.78019 6.53326 7.99164C6.53326 7.20309 7.17097 6.56372 7.95749 6.56372C8.744 6.56372 9.38171 7.20309 9.38171 7.99164C9.38171 8.78019 8.744 9.41956 7.95749 9.41956Z"
        fill="#5882FF"
      />
    </svg>
  );
};

export const GroupBuyTagIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 14 13.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="block flex-shrink-0"
  >
    <path
      d="M7.25 1.17L12.04 5.96Q12.75 6.67 12.04 7.38L7.96 11.46Q7.25 12.17 6.54 11.46L1.75 6.67V2.97C1.75 1.98 2.56 1.17 3.55 1.17H7.25Z"
      fill="#F16B7C"
    />
    <circle cx="4.6" cy="4" r="0.875" fill="white" />
  </svg>
);

export const GroupBuyTruckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 -1.2 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="block flex-shrink-0"
  >
    <path
      d="M1 2.5C1 1.94772 1.44772 1.5 2 1.5H8.5C9.05228 1.5 9.5 1.94772 9.5 2.5V11H6.5C6.5 10.1716 5.82843 9.5 5 9.5C4.17157 9.5 3.5 10.1716 3.5 11H1V2.5Z"
      fill="#F16B7C"
    />
    <path
      d="M10.5 5C10.5 4.44772 10.9477 4 11.5 4H13L15 7V10C15 10.5523 14.5523 11 14 11H13.5C13.5 10.1716 12.8284 9.5 12 9.5C11.1716 9.5 10.5 10.1716 10.5 11V5Z"
      fill="#F16B7C"
    />
    <circle cx="5" cy="11" r="1.5" fill="#F16B7C" stroke="white" strokeWidth="1" />
    <circle cx="11.5" cy="11" r="1.5" fill="#F16B7C" stroke="white" strokeWidth="1" />
  </svg>
);

export const MetricDripSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 2C8 2 4 6.798 4 9.05096C4 11.3039 5.79083 13.1304 8 13.1304C10.2092 13.1304 12 11.3039 12 9.05096C12 6.798 8 2 8 2Z"
        fill="#5882FF"
      />
    </svg>
  );
};

export const ArrowRightSvg = (props) => {
  const { color = '#F16B7C' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.293 3.29303C10.4805 3.10556 10.7348 3.00024 11 3.00024C11.2652 3.00024 11.5195 3.10556 11.707 3.29303L17.707 9.29303C17.8945 9.48056 17.9998 9.73487 17.9998 10C17.9998 10.2652 17.8945 10.5195 17.707 10.707L11.707 16.707C11.5184 16.8892 11.2658 16.99 11.0036 16.9877C10.7414 16.9854 10.4906 16.8803 10.3052 16.6948C10.1198 16.5094 10.0146 16.2586 10.0123 15.9964C10.01 15.7342 10.1108 15.4816 10.293 15.293L14.586 11H3C2.73478 11 2.48043 10.8947 2.29289 10.7071C2.10536 10.5196 2 10.2652 2 10C2 9.73481 2.10536 9.48046 2.29289 9.29292C2.48043 9.10539 2.73478 9.00003 3 9.00003H14.586L10.293 4.70703C10.1055 4.5195 10.0002 4.26519 10.0002 4.00003C10.0002 3.73487 10.1055 3.48056 10.293 3.29303Z"
        fill={color}
      />
    </svg>
  );
};
